import React, { useRef, useState } from "react";
import { toAbsoluteUrl } from "_metronic/helpers";
import { UploadProps } from "./types";
import { KTSVGWhite } from "_metronic/helpers/components/KTSVGWhite";

const UploadButton: React.FC<UploadProps> = ({
    onChange,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const onCLickUpload = () => {
        inputRef.current!.click();
    };
    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange!(e.target.files);
    };
    return (
        <div className="d-flex align-items-center">
            <input
                className="d-none"
                type="file"
                name="documentos"
                ref={inputRef}
                onChange={handleFileSelect}
                accept=".xlsx, .xlsm, .txt, .pdf, .jpg, .png"
            />
            <button
                className="badge badge-light-danger text-hover-secondary fw-bold px-4 py-3 cursor-pointer"
                style={{ backgroundColor: '#FA212A', border: 'none' }}
                onClick={onCLickUpload}
            >
                <KTSVGWhite
                    path="/media/icons/duotune/files/fil010white.svg"
                    className=""
                />
            </button>
        </div>
    );
};

export default UploadButton;
